import React from 'react'
import { Link } from 'react-router-dom'
import './CustomNavigation.css'


const CustomNavigation = () => {
  return (
    <div className="custom-nav">
      <a href="https://elitepartyz.com/win/">
            <h4> Win </h4>
        </a>
    </div>
  )
}

export default CustomNavigation